export const translate: {
	[key: string]: string
} = {
	'recruitment news. Find a latest, quickly jobs 24 hours nationwide!':
		'tin tuyển dụng, tìm việc làm nhanh 24h mới nhất trên toàn quốc!',
	'Reach 10,000+ opportunities to apply for jobs at leading companies. New jobs every day with high salaries and good benefits.':
		'Tiếp cận 10,000+ doanh nghiệp tuyển dụng uy tín. Việc làm mới mỗi ngày với mức lương cao, hấp dẫn, chế độ đãi ngộ cực tốt!',
	'Urgent Jobs': 'Tuyển dụng Gấp',
	'Hot Jobs': 'Việc làm đang Hot',
	'Best Jobs': 'Việc làm tốt nhất',
	'Top Recruitment Companies': 'Các công ty tuyển dụng hàng đầu',
	'High Salary Works': 'Việc làm lương cao',
	'Part Time Jobs': 'Việc làm bán thời gian',
	'Jobs From Top Headhunters': 'Việc làm công ty đầu ngành',
	'Hot Keywords': 'Từ khóa phổ biến',
	'Search Job by Industry': 'Tìm việc theo Ngành Nghề',
	'Search Job by Level': 'Tìm việc theo Cấp Bậc',
	'Search Job by Working Type': 'Tìm việc theo Loại Hình Công Việc',
	'Jobs by Location': 'Việc làm theo Khu Vực/Địa Điểm'
}
